export default function CUserInput() {
  return <h2>C User Input</h2>;
}
